import { User } from 'entities/user.entity';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Validator from 'utils/validator';
import { Role } from '..';

const EditMemberDrawer = ({ userData, setOpenDrawer }: { userData: User; setOpenDrawer: Dispatch<SetStateAction<boolean>> }) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors, isDirty },
    reset,
    trigger,
  } = useFormContext<User>();

  const roleTypeList: {
    value: Role.Owner | Role.Manager | Role.Viewer;
    text: string;
  }[] = [
    { value: Role.Manager, text: t('profile.memberRoleManager') },
    { value: Role.Viewer, text: t('profile.memberRoleViewer') },
  ];

  const resetForm = () => {
    reset();
    setOpenDrawer(false);
  };

  useEffect(() => {
    reset({
      email: userData.email,
      name: userData.name,
      cloud: userData.cloud,
      role: userData.role,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  useEffect(() => {
    Object.keys(errors).length > 0 && trigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t]);

  return (
    <>
      <div className="flex flex-col flex-nowrap overflow-y-auto overflow-x-hidden h-full pt-3">
        <h2 className="p-4 mb-2 text-gray-900 font-semibold text-[17px]">{userData.name}</h2>
        <div className="flex flex-col gap-6">
          <div className="px-4">
            <label className="text-sm">{t('profile.name')}</label>
            <div className="flex flex-col space-y-1 flex-1">
              <input type="text" className="input max-w-xs" {...register('name')} disabled />
            </div>
          </div>
          <div className="px-4">
            <label className="text-sm">{t('profile.email')}</label>
            <div className="flex flex-col space-y-1 flex-1">
              <input type="text" className="input max-w-xs" {...register('email')} disabled />
            </div>
          </div>
          <div className="px-4">
            <label className="text-sm">{t('profile.role')}</label>
            <div className="flex flex-row flex-wrap">
              {roleTypeList.map((roleType, index) => (
                <div className="form-control" key={index}>
                  <label className="label py-1 cursor-pointer">
                    <input type="radio" className="radio" {...register('role', { required: Validator().required })} value={roleType.value} />
                    <span className="label-text px-2">{roleType.text}</span>
                  </label>
                </div>
              ))}
            </div>
            {errors.role && <span className="span-error">{errors.role.message}</span>}
          </div>
          {/* NOTE: 目前無該功能 */}
          <div className="px-4 hidden">
            <label className="text-sm">{t('profile.memberGroups')}</label>
            <div className="flex flex-col space-y-1 flex-1">
              <input type="text" placeholder={''} className="input max-w-xs" {...register('cloud')} disabled={userData.role !== Role.Owner} />
            </div>
          </div>
          {/* NOTE: 目前無該欄位 */}
          <div className="px-4 hidden">
            <label className="text-sm">{t('profile.description')}</label>
            <div className="flex flex-col space-y-1 flex-1">
              <textarea className="textarea w-full max-w-xs h-[127px] textarea-bordered resize-none" {...register('cloud')}></textarea>
            </div>
          </div>
        </div>
      </div>
      {isDirty && (
        <div className="flex sticky w-full bottom-0 p-2 justify-end bg-gray-100">
          <div className="flex space-x-2">
            <button type="button" className="btn btn-outline" onClick={resetForm}>
              {t('modal.btnCancel')}
            </button>
            <button type="submit" className="btn btn-primary">
              {t('modal.btnApply')}
            </button>
          </div>
        </div>
      )}
    </>
  );
};
export default EditMemberDrawer;
